module.exports = __webpack_public_path__ + "static/media/welcomeView.88a97beb.jpg";